var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8438 7.64768C18.4948 7.01292 18.4948 5.98206 17.8438 5.34729C17.1927 4.71252 16.1354 4.71252 15.4844 5.34729L10 10.6996L4.51042 5.35237C3.85938 4.7176 2.80209 4.7176 2.15105 5.35237C1.50001 5.98713 1.50001 7.01799 2.15105 7.65276L7.64063 13L2.15626 18.3524C1.50521 18.9871 1.50521 20.018 2.15626 20.6528C2.8073 21.2875 3.86459 21.2875 4.51563 20.6528L10 15.3004L15.4896 20.6477C16.1406 21.2824 17.1979 21.2824 17.849 20.6477C18.5 20.0129 18.5 18.9821 17.849 18.3473L12.3594 13L17.8438 7.64768Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.bfab63bd5f649914d704514076423bc9.svg";
export { ForwardRef as ReactComponent };